import React from 'react'
import { Router } from "react-router-dom";
import { Provider } from "mobx-react";
import store from './src/Store'

exports.onRouteUpdate = ({location}) => {
  if (typeof window !== `undefined`) {
    if(location.hash === '') {
      window.scrollTo(0, 0)
    }
  }
}

exports.shouldUpdateScroll = args => {
   return false;
};

exports.replaceRouterComponent = ({ history }) => {
    return ({ children }) => (
        <Provider store={ store }>
            <Router history={history}>{children}</Router>
        </Provider>
    );
};



// WEBPACK FOOTER //
// ./gatsby-browser.js